if (!customElements.get('swiper-slider-slideshow')) {
  class SwiperSliderSlideshow extends HTMLElement {
    connectedCallback() {
      this.classList.add('swiper');

      const showPagination = this.dataset.showPagination === 'true';
      const showArrows = this.dataset.showArrows === 'true';
      const autoRotate = this.dataset.autoplay === 'true';
      const speed = parseInt(this.dataset.speed) || 5000;
      const swiperOptions = {
        loop: true,
        slidesPerView: 1,
        spaceBetween: 0,
        autoplay: autoRotate
          ? {
              delay: speed,
              disableOnInteraction: false,
            }
          : false,
      };
      if (showPagination) {
        swiperOptions.pagination = {
          el: this.querySelector('.swiper-pagination'),
          type: 'fraction',
        };
      }

      if (showArrows) {
        swiperOptions.navigation = {
          nextEl: this.querySelector('.swiper-button-next'),
          prevEl: this.querySelector('.swiper-button-prev'),
        };
      }

      const slides = Array.from(this.querySelectorAll('.swiper-slide'));
      const loadSlide = (slideEl) => {
        if (!slideEl) return;
        slideEl.querySelectorAll('img.slideshow__deferred').forEach((img) => {
          if (img.dataset.srcset) img.srcset = img.dataset.srcset;
          if (img.dataset.src) img.src = img.dataset.src;
          img.removeAttribute('data-srcset');
          img.removeAttribute('data-src');
          img.classList.remove('slideshow__deferred');
        });
      };
      const loadAll = () => slides.forEach(loadSlide);
      const loadAround = (swiper, withPrev) => {
        const list = swiper.slides;
        const n = list.length;
        if (!n) return;
        const i = swiper.activeIndex;
        loadSlide(list[i]);
        loadSlide(list[(i + 1) % n]);
        if (withPrev) loadSlide(list[(i - 1 + n) % n]);
      };

      if (typeof Swiper === 'undefined') {
        loadAll();
        return;
      }

      swiperOptions.on = {
        init: (swiper) => loadAround(swiper, false),
        slideChange: (swiper) => loadAround(swiper, true),
      };

      const onFirstInteraction = () => {
        this.removeEventListener('touchstart', onFirstInteraction);
        this.removeEventListener('pointerdown', onFirstInteraction);
        loadAll();
      };
      this.addEventListener('touchstart', onFirstInteraction, { passive: true, once: true });
      this.addEventListener('pointerdown', onFirstInteraction, { passive: true, once: true });

      new Swiper(this, swiperOptions);
    }
  }

  customElements.define('swiper-slider-slideshow', SwiperSliderSlideshow);
}
